"use client";
import { createTheme } from "@mui/material";

export const defaultTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      veryDark: "#203344",
      dark: "#294257",
      main: "#2e4a62",
      light: "#456f93",
      verylight: "#9bb7d0",
      extremelylight: "#cddbe7",
    },
    grey: {
      main: "#8f9397",
    },
    common: {
      white: "#fff",
      black: "#000",
    },
    error: {
      main: "#FF6B2C",
      background: "rgb(51,22,9)",
    },
    success: {
      main: "#81A85A",
      background: "rgb(26, 41, 8)",
    },
    warning: {
      main: "#FFCF5F",
      secondary: "#f6b519",
      background: "#3b3119",
    },
    disabled: {
      main: "#666564",
      secondary: "#A3A3A3",
    },
  },
  utils: {
    blur: "blur(5px)",
  },
});
